module.exports = __webpack_public_path__ + "img/logo-portal-trans.5a22e0cb.png";